import React from "react";
import Institutions from "../components/menu/general/InstitutionsMenu";

const Institusi = () => {
  return <Institutions />;
};
export default Institusi;
